import { render, staticRenderFns } from "./percent.vue?vue&type=template&id=3778524f&scoped=true&"
import script from "./percent.vue?vue&type=script&lang=js&"
export * from "./percent.vue?vue&type=script&lang=js&"
import style0 from "./percent.vue?vue&type=style&index=0&id=3778524f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3778524f",
  null
  
)

export default component.exports